export const CustomBlocksType = {
	PRODUCT_RECOMMENDATION: "product_recommendation",
	PRACTICE_SIGNATURE: "practice_signature",
};
